<script lang="ts">
  import MaskedInput from "./MaskedInput.svelte";
  const options = {
    mask: "(000) 000-0000",
  };
  export let value: string | null;
  export let disabled = false;
  export let required = false;
  export let viewOnly = false;
  export let onChange = null;
  export let action = null;
  export let onBlur = null;
  export let id = "";
  export let placeholder: string = "";
  export let label = "";
  export let description = "";
  export let errorMessage = "";
  export let onFocus = null;
  export let name: string = "";

  if (viewOnly) {
    disabled = true;
  }
  let classes = viewOnly ? "fake-input-fizz" : "";
  export let extraClasses = "";
  classes += " " + extraClasses;

</script>

{#if !(disabled && !value)}
  <MaskedInput
    {options}
    inputIdString={id}
    disable={disabled}
    require={required}
    bind:phoneInput={value}
    {classes}
    on:accept={onChange}
    {onBlur}
    {onFocus}
    {action}
    {placeholder}
    {label}
    {description}
    {errorMessage}
    {name}
  />
{/if}
